import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-avatar-widget',
  templateUrl: './avatar.widget.html'
})
export class MyAvatarWidgetComponent extends ControlWidget {
  public profile_url: String;

  readControl(schema, control) {
    if (schema.widget.id === 'sf-avatar') {
      this.profile_url = control.value;
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/avatar/avatar.widget.ts